import {
  call, put, takeEvery, select,
} from 'redux-saga/effects';
import userAPI from '../../api/UserAPI';
import { FETCH_USER_ROLE_REQUEST } from '../actions/types/UserActionTypes';
import { AUTH_LOGIN_SUCCESS } from '../../../redux/actions/types/authActionTypes';
import { fetchUserRoleSuccessActionCreator, fetchUserRoleFailureActionCreator } from '../actions/UserActions';
import { showNotification } from '../../../notifications/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../locales/locales';
import { languageSelector } from '../../../redux/selectors/languageSelector';

function* fetchUserRole() {
  const lang = yield select(languageSelector);
  try {
    const userRoleResponse = yield call(userAPI.apiFetchUserRole);
    const userRole = userRoleResponse.data;
    yield put(fetchUserRoleSuccessActionCreator(userRole));
  } catch (error) {
    yield put(fetchUserRoleFailureActionCreator(error));
    if (error.response.status === 403 && error.response.data.message === 'Access is denied') {
      yield put(showNotification({
        type: 'ERROR',
        message: formatMessage(lang, 'app.user.role.accessDenied'),
      }));
    }
  }
}

function* userWatcher() {
  yield takeEvery(FETCH_USER_ROLE_REQUEST, fetchUserRole);
  yield takeEvery(AUTH_LOGIN_SUCCESS, fetchUserRole);
}

export default userWatcher;
export {
  fetchUserRole,
};
